import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {fontSizes, fontWeights} from '../../../libs/shared/ui/src/styles/fontStyles';

/*
 * Props.
 */

interface SettingsFieldSectionProps {
  title: ReactNode;
  className?: string;
}

/*
 * Style.
 */

const StyledDiv = styled.div`
  display: grid;
  grid-template-areas:
    'top'
    'bottom';
  grid-template-columns: 1fr;
  grid-template-rows: max-content auto;
  grid-row-gap: 8px;
`;

const StyledTitleDiv = styled.div`
  font-weight: ${fontWeights.semibold};
  font-size: ${fontSizes.small};
  color: ${(p) => p.theme.greys.shade70};
  grid-area: top;
`;

const StyledBottomDiv = styled.div`
  grid-area: bottom;
  display: flex;
  flex-direction: column;
`;

/*
 * Component.
 */

export const SettingsFieldSection: FC<SettingsFieldSectionProps> = (props) => (
  <StyledDiv className={props.className}>
    <StyledTitleDiv>{props.title}</StyledTitleDiv>
    <StyledBottomDiv>{props.children}</StyledBottomDiv>
  </StyledDiv>
);
